module.exports = function getResource(label, vars = []) {
    let resources = {
        member: 'Membre',
        join: 'S’inscrire',
        new: `${vars[0]} nouveauté`
    };
    return resources[label];
};
